class MemoryStorage implements Storage {
  private data: Record<string, string> = {};

  [name: string]: unknown;

  get length() {
    return Object.keys(this.data).length;
  }

  key(index: number): string | null {
    return Object.values(this.data)[index] ?? null;
  }

  getItem(key: string) {
    return this.data[key] ?? null;
  }

  setItem(key: string, value: string) {
    this.data[key] = value;
  }

  removeItem(key: string) {
    delete this.data[key];
  }

  clear() {
    this.data = {};
  }
}

function isStorageAvailable(storage: Storage) {
  try {
    const key = '__storage_test__';
    storage.setItem(key, key);
    storage.removeItem(key);
    return true;
  } catch {}
  return false;
}

if (!isStorageAvailable(localStorage)) {
  window.localStorage = new MemoryStorage();
}

if (!isStorageAvailable(sessionStorage)) {
  window.sessionStorage = new MemoryStorage();
}
